import React, { useEffect, useState } from 'react'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Formik } from 'formik'
import { FormikTextField } from '../../CommonComponents/FormField'
import MasterService from '../../Masters/MasterService'
import { Autocomplete, Checkbox, FormControl, InputAdornment, InputLabel, ListItemText, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material'
import { userid } from '../../Common/Credentials'
import SubscriptionServices from './SubscriptionServices'
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb'
import TextfieldComponent from '../../Component/TextfieldComponent'
import { errors } from '@sideway/address'
import SelectField from '../../NewUI/NewComponents/SelectField'
import AutoCompeteField from '../../NewUI/NewComponents/AutoCompeteField'

const SubscriptionPacks = () => {
  
  const navigate = useNavigate()

  const [title,setTitle] = useState("")
  const [description,setDescription] = useState("")
  const [discount, setDiscount] = useState()
  const [price,setPrice] = useState()
  const [offerprice,setOfferprice] = useState(0)
  const [currency,setCurrency] = useState(null)
  const [CountryData,setCountryData] = useState([])
  const [country,setCountry] = useState([])
  const plantypes = ["SAASMonthly","SAASQuarterly","SAASYearly","Request Demo"]
  const [selectedPlan,setSelectedPlan] = useState("Monthly")
  const [personName, setPersonName] = useState([]);
  const [productsList,setProductsList] = useState([])
  const [currencyList,setCurrencyList] = useState([])
  const [benifit,setBenifit] = useState("")
  const [planbenifits,setPlanbenifits] = useState([])
  const [list,setList] = useState([]) 
 
  useEffect(()=>{

    MasterService.getCountries()
      .then((response) =>
        setCountryData(response.data)
      )
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate(`/`);
        }
      });
      MasterService.getAllProducts().then((res)=>{
        setProductsList(res.data)
      })

      MasterService.GetAllCurrency().then((res)=>{
        setCurrencyList(res.data)
      })

  },[])

  const ChangeCountry = (event) => {
    const {
      target: { value },
    } = event;
    setCountry(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  }

  const ChangeCurrency = (val,values) =>{
    setCurrency(values)
  }

  

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleAdd = () =>{
    let datalist = []

    country.map(c=>{
      datalist.push({
          country:c,
          currency:currency.currency,
          price:parseFloat(price)  
    })
  })
  setList([...list,...datalist])
  setCountry([])
  }

  const OnSubmit = (e) =>{
    let data = {
      products:productsList.map(e=>e.id).toString(),
      title:title,
      description:description,
      planbenifits:JSON.stringify(planbenifits),
      subscriptionpricies:list,
      createdby:userid,
      updatedby:userid,
      enguagmenttype:selectedPlan,
    }

    SubscriptionServices.addsubscriptionplan(data).then(()=>navigate("/subscriptions"))
  }

  return (
    <div>
    <Header />
    <Menu />
    <div className="content-wrapper">
    <div className='UI-container'>
        <div className={`UI-header`}>
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"Tenants",path:null}]}/>
        </div>
                    <div className="UI-form-card ">
          <Formik
            initialValues={{}}
            onSubmit={OnSubmit}
                >
                {({ setFieldValue, values,errors }) => (
                  <Form>
                     <div className="form-row">
                      <fieldset className='col-md-3'>
                      <FormControl fullWidth>
                          <div className="UI-label">Select Products</div>
                          <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            value={personName}
                            onChange={handleChange}
                            // input={<OutlinedInput label="Tag" />}
                            renderValue={(selected) => selected.join(', ')}
                            // MenuProps={MenuProps}
                            fullWidth
                            size='small'
                          >
                            {productsList.map((product) => (
                              <MenuItem key={product.id} value={product.products}>
                                <Checkbox checked={personName.includes(product.products)} />
                                <ListItemText primary={product.products} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </fieldset>
                     <fieldset className="col-md-3">
                     <TextfieldComponent className="form-control" type="text" name="title" label="Title" value={title} onChange={(e) =>setTitle(e.target.value)} error={errors?.title} required/>
                      </fieldset>
                      <fieldset className="col-md-6">
                     <TextfieldComponent type="text" name="description" label="Description" value={description} onChange={(e) => setDescription(e.target.value)} error={errors?.description} required/>
                      </fieldset>
                      </div>
                      <div className="form-row">
                      <fieldset className='col-md-3'>
                      <SelectField label="Select Plan Type" list={plantypes} lableKey={null} lableValue={null} value={selectedPlan} onChange={(e)=>setSelectedPlan(e.target.value)} error={errors?.plantype} required/>
                      </fieldset>
                      <fieldset className="col-md-3">
                      <FormControl fullWidth>
                          <div className="UI-label">Select Countries</div>
                          <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            value={country}
                            onChange={ChangeCountry}
                            // input={<OutlinedInput label="Tag" />}
                            renderValue={(selected) => selected.join(', ')}
                            // MenuProps={MenuProps}
                            fullWidth
                            size='small'
                          >
                            {CountryData.map((c) => (
                              <MenuItem key={c.id} value={c.name}>
                                <Checkbox checked={country.includes(c.name)} />
                                <ListItemText primary={c.name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {/* <Autocomplete
                          id="country"
                          className="subacc-select"
                          name="country"
                          options={CountryData}
                          getOptionLabel={(option) => option.name}
                          value={country}
                          onChange={ChangeCountry}
                          renderInput={(params) => (
                            <FormikTextField
                              {...params}
                              className="form-control"
                              type="text"
                              name="country"
                              label={`Select Country`}
                              variant="standard"
                              fullWidth
                            />
                          )}
                        /> */}
                      </fieldset>
                      <fieldset className="col-md-3">
                      <AutoCompeteField id="currency" name="currency" options={currencyList} label="Select Currency" value={currency} labelKey={"currency"} valueKey={"currency"} onChange={ChangeCurrency} error={errors?.currency} required/>
{/* 
                        <Autocomplete
                          id="currency"
                          className="subacc-select"
                          name="currency"
                          options={currencyList}
                          getOptionLabel={(option) => option.currency}
                          value={currency}
                          onChange={ChangeCurrency}
                          renderInput={(params) => (
                            <FormikTextField
                              {...params}
                              className="form-control"
                              type="text"
                              name="currency"
                              label={`Select Currency`}
                              variant="standard"
                              fullWidth
                            />
                          )}
                        /> */}
                      </fieldset>
                     <fieldset className="col-md-3">
                     <TextfieldComponent type="number" name="price" label="Price" value={price} onChange={(e) => setPrice(e.target.value)} prefix={currency?.currency || currency?.symbol || ""}/> 
                      </fieldset>
                      <fieldset className="col-md-2 tw-my-2">
                      <button className="UI-btn UI-btn-primary tw-mr-2" type="button" onClick={handleAdd}>Add</button>
                      </fieldset>
                      {/* <fieldset className="col-md-3">
                     <FormikTextField
                          className="form-control"
                          type="text"
                          name="discount"
                          label="Discount/Markup"
                          value={discount}
                          onChange={(e) =>
                            setDiscount(e.target.value)
                          }
                        />
                      </fieldset>
                      <fieldset className="col-md-3">
                     <FormikTextField
                          className="form-control"
                          type="text"
                          name="offerprice"
                          label="Offer Price"
                          value={offerprice}
                          onChange={(e) =>
                            setOfferprice(e.target.value)
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {currency}
                              </InputAdornment>
                            ),
                          }}
                
                        />
                      </fieldset> */}

                      <fieldset className="col-md-12">
                        <Table size='small'>
                          <TableHead>
                            <TableRow>
                            <TableCell>Country</TableCell>
                            <TableCell>Currency</TableCell>
                            <TableCell>Price</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {list.length>0?list.map((e,i)=>
                          <TableRow>
                             <TableCell>{e.country}</TableCell>
                             <TableCell>{e.currency}</TableCell>
                             <TableCell>{e.price}</TableCell>
                          </TableRow>
                          ): <TableRow>
                             <TableCell colSpan={3} align='center'>No data </TableCell></TableRow>}
                          </TableBody>
                        </Table>
                      </fieldset>

                      <fieldset className='col-md-12 form-row'>
                      <fieldset className="col-md-3">
                     <TextfieldComponent type="text" name="benifit" label="Plan Benifits" value={benifit} onChange={(e) => setBenifit(e.target.value)}/>
                      </fieldset>
                      <fieldset className="col-md-2 tw-mt-auto tw-mb-1">
                      <button className="btn btn-sm hovbuttonColour tw-mr-2 tw-py-2 tw-px-4" type="button" disabled={benifit === null || benifit ===undefined || benifit ===""} onClick={()=>{setPlanbenifits([...planbenifits,benifit]);setBenifit("")}}>Add</button>
                      </fieldset>
                      </fieldset>

                      <fieldset className='col-md-12'>
                      <div className="tw-my-3 tw-max-w-4xl tw-grid tw-grid-cols-1 tw-gap-8 sm:tw-grid-cols-2 lg:tw-grid-cols-2">
        <div className="tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-shadow tw-p-8 tw-flex tw-flex-col">
          <h3 className="tw-text-xl tw-font-semibold tw-text-blue-600">{title}</h3>
          <p className="tw-mt-4 tw-text-3xl tw-font-bold tw-text-gray-900"><span className='tw-text-base tw-font-normal'>{currency?currency?.currency:""}</span> {price}<span className="tw-text-base tw-font-normal">/{selectedPlan}</span></p>
          <p className="tw-mt-2 tw-text-gray-600">{description}</p>
          <ul className="tw-my-6 tw-space-y-4 tw-flex-grow">
            {planbenifits.length>0?planbenifits.map((e,i)=>
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>{e}<span className=" tw-mr-2 tw-cursor-pointer tw-text-red-600 ml-2" onClick={()=>setPlanbenifits(planbenifits.filter((f,idx)=>i!==idx))}>❌</span>
            </li>)
            : <li className="tw-flex tw-items-center tw-text-gray-600">
            <span className="tw-text-blue-600 tw-mr-2">✔️</span>Add Plan Benifits
          </li>}
          </ul>
          {/* <RazorpayCheckout handlePaymentUpdate={handlePaymentUpdate}/> */}
          <button type='button'
       className="tw-mt-auto tw-w-full tw-text-black tw-bg-[#FDD60E] hover:tw-bg-[#FDD60Ecc] tw-py-3 tw-rounded-lg tw-transition tw-duration-300 tw-outline-none tw-items-center"
      >Subscribe</button>
        </div>
        </div>
                      </fieldset>
                      <fieldset className="col-md-12 tw-flex tw-justify-end">
                      <button
                                      className="UI-btn UI-btn-primary tw-mr-2"
                                      type="submit"
                                    >
                                      Save
                                    </button>
                                    <Link
                        as="button"
                        className="UI-btn UI-btn-outline col-md-auto col-sm-12"
                        to={{ pathname: "/superadminmasters" }}
                      >Cancel
                      </Link>
                                    </fieldset>
                      </div>
                    </Form>
                )}
           </Formik>
           </div>
           </div>
           </div>

    </div>
  )
}

export default SubscriptionPacks